<template>
	<div class="filter-view">
		<FilterCard :add="true">
		</FilterCard>
	</div>
</template>

<script>
import FilterCard from './FilterCard'

export default {
	name: 'add-filter',

	components: {
		FilterCard
	}
}
</script>

<style lang="scss" scoped>
@import "@/module/app/theme/color.scss";

.filter-view {
	padding: 15px 20px;
	background-color: $grey-100;

	.el-card {
		margin-top: 5px;
		margin-bottom: 10px;
		overflow: visible;
	}
	.el-card__header {
		overflow: visible;
		padding: 0 !important;
		position: relative;
		height: 40px;
		line-height: 40px;
		background: #fafafa;
	}
	> .el-card > .el-card__body {
		padding: 0;
	}
	.el-table__expanded-cell {
		padding: 0 !important;
	}
	.el-table__body td {
		word-break: normal;
	}
}
</style>
